import React from 'react';

type SemiCircleProgressProps = {
  strokeWidth: number;
  strokeLinecap?: 'butt' | 'round' | 'square' | 'inherit';
  percentage: number;
  size: {
    width: number;
    height: number;
  };
  disabled?: boolean;
  danger?: boolean;
};

export const SemiCircleProgress = ({
  strokeWidth,
  percentage,
  size,
  strokeLinecap,
  disabled,
  danger,
}: SemiCircleProgressProps) => {
  const radius = 50 - strokeWidth / 2;
  const circumference = 1.1 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  const bgStrokeDashoffset = circumference - 1 * circumference;
  const pathDescription = 'M5,64 a1,1 0 0,1 90,0';

  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox='0 0 100 100'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='half-circular-progress mb-[-30px]'
    >
      <path
        cx='45'
        cy='45'
        r='32'
        d={pathDescription}
        style={{
          strokeLinecap: strokeLinecap || 'round',
          strokeDasharray: `${circumference}`,
          strokeDashoffset: `${bgStrokeDashoffset}`,
          strokeWidth: `${strokeWidth + 1}`,
        }}
        className={
          disabled
            ? 'stroke-outline-primary-bw-03'
            : danger
              ? 'stroke-outline-primary-bw-03'
              : 'stroke-outline-brand-tertiary'
        }
      />

      <path
        cx='45'
        cy='45'
        r='32'
        d={pathDescription}
        style={{
          transition: 'stroke-dashoffset 0.35s',
          strokeLinecap: strokeLinecap || 'round',
          strokeDasharray: `${circumference}`,
          strokeDashoffset: `${bgStrokeDashoffset}`,
          strokeWidth: `${strokeWidth}`,
        }}
        className={
          disabled
            ? 'stroke-outline-primary-bw-03'
            : danger
              ? 'stroke-outline-primary-bw-02'
              : 'stroke-outline-brand-primary-inverse'
        }
        fill='none'
      />

      <path
        cx='45'
        cy='45'
        r='32'
        d={pathDescription}
        style={{
          transition: 'stroke-dashoffset 0.35s',
          strokeLinecap: strokeLinecap || 'round',
          strokeDasharray: `${disabled ? '' : circumference}`,
          strokeDashoffset: `${strokeDashoffset}`,
          strokeWidth: `${strokeWidth}`,
        }}
        className={
          disabled
            ? 'stroke-outline-primary-bw-03'
            : danger
              ? 'stroke-outline-orange-primary'
              : 'stroke-surface-brand-action-03'
        }
        fill='none'
      />
      <animate attributeName='stroke-dashoffset' from='283' to='0' dur='1s' fill='freeze' />
    </svg>
  );
};
